// extracted by mini-css-extract-plugin
export default {"diffTitle":"LinkClaimDiff_diffTitle__WR5xa","claimDiffContainer":"LinkClaimDiff_claimDiffContainer__D8HMS"};